const { expect } = require('chai');
const { jpath } = require('jsonpath-mapper');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Copy the content of a field using a LiquidJS template', () => {
  describe('preview copying a simple string field with template applied', () => {
    const mock = loadRecordedMock('copy_field_template_string_preview.json');
    const n = 18;
    it(`should return ${n} entries to update`, (done) => {
      migratortronApi.post(
        'copy/field?template&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });
  describe('copy a simple string field with template applied', () => {
    const mock = loadRecordedMock('copy_field_commit_template_string.json');
    const n = 18;
    it(`should update ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?template&string',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(n);
          done();
        }
      );
    });
  });
  describe('repeat the same copy a simple string field with template applied', () => {
    const mock = loadRecordedMock(
      'copy_field_commit_template_string_repeat.json'
    );
    const n = 20;
    it(`should return ${n} entries`, (done) => {
      migratortronApi.post(
        'copy/field/commit?template&string&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body && typeof body === 'object').to.be.true;
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(n);
          expect(jpath('existing.*.totalCount', body)).to.equal(n);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });
});
